"use client";

export function preloadImages(srcs: string[]) {
	return Promise.all(
		srcs.map(
			(src) =>
				new Promise<void>((resolve) => {
					const img = new window.Image();
					img.onload = () => resolve();
					img.onerror = () => resolve();
					img.src = src;
				}),
		),
	);
}
